var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8287)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 49.0232C23.3737 49.0235 21.7516 48.86 20.1583 48.5349C17.0854 47.9056 14.1665 46.6773 11.5682 44.9202C7.70582 42.313 4.68242 38.6417 2.86425 34.3511C2.25002 32.8977 1.7812 31.3872 1.46464 29.8415C0.81387 26.6466 0.81387 23.3532 1.46464 20.1583C2.09393 17.0854 3.32214 14.1665 5.07919 11.5681C7.68653 7.70573 11.358 4.68233 15.6488 2.86424C17.1021 2.25002 18.6126 1.78119 20.1582 1.46463C23.3531 0.813874 26.6464 0.813874 29.8413 1.46463C32.9142 2.09396 35.8332 3.32224 38.4315 5.07937C42.2939 7.68673 45.3173 11.3582 47.1353 15.649C47.7496 17.1023 48.2184 18.6127 48.535 20.1584C49.1857 23.3533 49.1857 26.6466 48.535 29.8416C47.9056 32.9145 46.6773 35.8335 44.9202 38.4318C42.3129 42.2942 38.6414 45.3176 34.3506 47.1357C32.8973 47.75 31.3868 48.2189 29.8411 48.5355C28.2478 48.8603 26.6259 49.0237 24.9998 49.0232ZM15.6697 11.0174C15.3273 11.0152 14.9888 11.0909 14.6799 11.2386C14.3709 11.3864 14.0996 11.6024 13.8863 11.8703L11.7308 14.46C11.2664 15.0169 11.0137 15.72 11.0174 16.4451V35.8299C11.0184 36.6521 11.3455 37.4404 11.9269 38.0219C12.5084 38.6033 13.2967 38.9304 14.1189 38.9314H35.8299C36.6521 38.9304 37.4404 38.6033 38.0219 38.0219C38.6033 37.4404 38.9304 36.6521 38.9314 35.8299V16.4451C38.9334 15.7229 38.6871 15.0221 38.2336 14.46L36.078 11.8547C35.8584 11.5911 35.5833 11.3793 35.2723 11.2346C34.9613 11.0898 34.6221 11.0156 34.2791 11.0173L15.6697 11.0174ZM28.076 32.7286H21.8729V29.627H16.4451L24.9745 21.0976L33.5039 29.627H28.076V32.7285V32.7286ZM35.6286 14.1189H14.3051L15.5767 12.5681H34.1863L35.6284 14.1187L35.6286 14.1189Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.feb068a199b27acfb5e8ce1e094a0cae.svg";
export { ForwardRef as ReactComponent };